import { render, staticRenderFns } from "./joinHomeModel.vue?vue&type=template&id=6a3ec3a6&scoped=true&"
import script from "./joinHomeModel.vue?vue&type=script&lang=js&"
export * from "./joinHomeModel.vue?vue&type=script&lang=js&"
import style0 from "./joinHomeModel.vue?vue&type=style&index=0&id=6a3ec3a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ec3a6",
  null
  
)

export default component.exports